import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["displayMode", "editMode", "nameInput", "form"]

  enterEditMode() {
    if (this.hasDisplayModeTarget) this.displayModeTarget.classList.add("hidden")
    if (this.hasEditModeTarget) this.editModeTarget.classList.remove("hidden")
    if (this.hasNameInputTarget) this.nameInputTarget.focus()
  }

  cancel(event) {
    if (event) event.preventDefault()
    if (this.hasFormTarget) this.formTarget.reset()
    if (this.hasDisplayModeTarget) this.displayModeTarget.classList.remove("hidden")
    if (this.hasEditModeTarget) this.editModeTarget.classList.add("hidden")
  }

  submitForm(event) {
    event.preventDefault()
    if (this.hasFormTarget) this.formTarget.requestSubmit()
  }
}
